import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import customChannelResource, { CustomChannel } from 'src/actions/channels/customChannelResource';

const useToggleArchive = () => {
  const dispatch = useDispatch();

  const [isArchiveModalVisible, setArchiveModalVisible] = useState(false);
  const [customChannel, setCustomChannel] = useState<CustomChannel>();

  const openArchiveModal = item => {
    setCustomChannel(item);
    setArchiveModalVisible(true);
  };

  const closeArchiveModal = () => {
    setArchiveModalVisible(false);
  };

  const updateCustomChannel = useCallback(
    item => {
      if (!item) {
        return;
      }

      const action = item.archived ? 'archived' : 'unarchived';

      dispatch(
        customChannelResource.effects.update({ id: item.id }, item, {
          customToastMsg: `"${item.name}" has been ${action}.`,
        })
      );
      setArchiveModalVisible(false);
    },
    [dispatch]
  );

  const unarchive = useCallback(
    item => {
      setCustomChannel(item);

      updateCustomChannel({ ...item, archived: false });
    },
    [updateCustomChannel, setCustomChannel]
  );

  const archive = useCallback(
    item => {
      setCustomChannel(item);

      updateCustomChannel({ ...item, archived: true });
    },
    [updateCustomChannel, setCustomChannel]
  );

  return {
    archive,
    closeArchiveModal,
    customChannel,
    isArchiveModalVisible,
    openArchiveModal,
    setCustomChannel,
    unarchive,
  };
};

export default useToggleArchive;
